import React from 'react'
import { Link, Outlet } from 'react-router-dom'
import Menu from './Menu'
import Top from './Top'
import ManifestSEO from '../../components/ManifestSEO'
import PageBanner from '../../components/PageBanner'
import socialLinks from '../../config/socialLinks'

export default function Layout() {
    return (
        <>
            <ManifestSEO />
            <Top />
            <Menu />
            <PageBanner />
            <Outlet />
            <div className="container-fluid footer position-relative bg-dark text-white-50 py-5 wow fadeIn" data-wow-delay="0.1s">
                <div className="container">
                    <div className="row g-5 py-5">
                        <div className="col-lg-6 pe-lg-5">
                            <Link to="/" className="navbar-brand">
                                <h1 className="h1 text-primary mb-0">100Eyes<span className="text-white"> Technologies</span></h1>
                            </Link>
                            <p className="fs-5 mb-4">100Eyes Technologies LLP provides enterprise-grade software solutions and consultancy. We build reliable, scalable products for our clients.</p>
                            <p><i className="fa fa-map-marker-alt me-2" />North Delhi, India</p>
                            <p><i className="fa fa-phone-alt me-2" />+91 7011158577</p>
                            <p><i className="fa fa-envelope me-2" />info@100eyestechnologies.com</p>
                            <div className="d-flex mt-4">
                                <a className="btn btn-lg-square btn-primary me-2" href={socialLinks.twitter} target="_blank" rel="noopener noreferrer"><i className="fab fa-twitter" /></a>
                                <a className="btn btn-lg-square btn-primary me-2" href={socialLinks.facebook} target="_blank" rel="noopener noreferrer"><i className="fab fa-facebook-f" /></a>
                                <a className="btn btn-lg-square btn-primary me-2" href={socialLinks.linkedin} target="_blank" rel="noopener noreferrer"><i className="fab fa-linkedin-in" /></a>
                                <a className="btn btn-lg-square btn-primary me-2" href={socialLinks.instagram} target="_blank" rel="noopener noreferrer"><i className="fab fa-instagram" /></a>
                            </div>
                        </div>
                        <div className="col-lg-6 ps-lg-5">
                            <div className="row g-5">
                                <div className="col-sm-6">
                                    <h4 className="text-light mb-4">Quick Links</h4>
                                    <Link className="btn btn-link" to="/about-us">About Us</Link>
                                    <Link className="btn btn-link" to="/contact-us">Contact Us</Link>
                                    <Link className="btn btn-link" to="/service">Our Services</Link>
                                    <Link className="btn btn-link" to="/blogs">Blogs</Link>
                                    <Link className="btn btn-link" to="/call-us">Call Us</Link>
                                    {/* Outbound resources to provide authoritative references */}
                                    <div className="mt-3">
                                        <a className="btn btn-link text-decoration-underline" href="https://developer.mozilla.org/en-US/docs/Web/Performance" target="_blank" rel="noopener noreferrer">Web Performance (MDN)</a>
                                        <a className="btn btn-link text-decoration-underline" href="https://developers.google.com/search/docs/beginner/seo-starter-guide" target="_blank" rel="noopener noreferrer">Google SEO Guide</a>
                                    </div>
                                </div>
                                <div className="col-sm-6">
                                    <h4 className="text-light mb-4">Legal</h4>
                                    <Link className="btn btn-link" to="/privacy-policy">Privacy Policy</Link>
                                    <Link className="btn btn-link" to="/terms-and-conditions">Terms &amp; Conditions</Link>
                                    <Link className="btn btn-link" to="/sitemap">Site Map</Link>
                                </div>
                                <div className="col-sm-12 d-none">
                                    <h4 className="text-light mb-4">Newsletter</h4>
                                    <div className="w-100">
                                        <div className="input-group">
                                            <input type="text" className="form-control border-0 py-3 px-4" style={{ background: 'rgba(255, 255, 255, .1)' }} placeholder="Your Email Address" /><button className="btn btn-primary px-4">Sign Up</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* Footer End */}
            {/* Certifications Section */}
            <div className="container-fluid bg-dark text-white-50 py-4 border-top border-primary">
                <div className="container">
                    <div className="row g-4 align-items-center">
                        <div className="col-md-6">
                            <h5 className="text-light mb-3">Certifications</h5>
                            <p className="mb-2"><i className="fa fa-check-circle text-primary me-2" />GST Certified Organization</p>
                            <p className="mb-0"><i className="fa fa-check-circle text-primary me-2" />ISO 9001:2015 Certified</p>
                        </div>
                        <div className="col-md-6 text-md-end">
                            <small className="text-muted">Committed to quality, compliance, and customer satisfaction.</small>
                        </div>
                    </div>
                </div>
            </div>
            {/* Certifications End */}

       
                {/* Copyright Start */}
                <div className="container-fluid copyright bg-dark text-white-50 py-4">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-6 text-center text-md-start">
                                <p className="mb-0">© 2025 100Eyes Technologies LLP. All Rights Reserved.</p>
                            </div>
                            <div className="col-md-6 text-center text-md-end">
                                <p className="mb-0">Designed by 100Eyes Technologies</p>
                            </div>
                        </div>
                    </div>
                </div>
                {/* Copyright End */}
                {/* Back to Top */}
                <button onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })} className="btn btn-lg btn-primary btn-lg-square rounded-circle back-to-top"><i className="bi bi-arrow-up" /></button>
       

        </>
    )
}
